import { motion } from 'framer-motion';
import styled from 'styled-components';

import { fadeTransition, FadeVariant, fadeVariants } from '@pkg/motion';
import { CommonAction, recipesCommonAction, styledTypography } from '@pkg/primitives';

import { tokens } from '../../DataTable.tokens';

export const Wrapper = styled(motion.div).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})`
    div[data-table-collapse='collapse'] + & {
        // Applying a 'margin-top' is necessary because
        // the <table /> uses 'border-spacing' (when 'separated')
        // which includes a trailing space.
        margin-top: ${tokens.row.gap}px;
    }
`;

export const Action = styled(CommonAction)`
    ${recipesCommonAction.basic};
    padding: ${tokens.cell.padding}px;
    width: 100%;
    height: ${tokens.cellContent.idealHeight}px;
    background-color: rgb(255, 255, 255, 0.06);

    // &[data-button-static] {}

    &:disabled {
        opacity: 0.8;
    }

    &:hover:not(:active) {
        background-color: rgb(255, 255, 255, 0.1);
    }
`;

export const Label = styled(motion.p).attrs({
    variants: fadeVariants,
    initial: FadeVariant.Hidden,
    animate: FadeVariant.Show,
    exit: FadeVariant.Hidden,
    transition: fadeTransition,
})`
    ${styledTypography.allianceBase};
    ${styledTypography.textBoxTrim};
    font-size: ${tokens.loadAction.fontSize}px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;
